import { render } from "./TariffActionSelect.vue?vue&type=template&id=fe5c8912"
import script from "./TariffActionSelect.vue?vue&type=script&lang=js"
export * from "./TariffActionSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__